import React, { Fragment, useEffect, useState } from 'react';
import {css, Global, keyframes} from '@emotion/react';
import {BrowserRouter as Router, Switch, Route, Redirect, useHistory, Link} from 'react-router-dom';
import {BtnBorder, BtnSubmit} from '../components/buttons';

import api from '../api';
import auth from '../auth';
import validate from '../validate';

import LogoImage from 'url:../images/logo@2x.png';
import {Form, FormControl, FormError} from '../components/form';
import {Wrap, Float} from '../components/common';
import {Helmet} from 'react-helmet';
import config from '../config';
const {siteName} = config;

export default () => {
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const [first_submit, setFirstSubmit] = useState(true);
  const [success, setSuccess] = useState(false);
  const [panic, setPanic] = useState(null);

  useEffect(() => {
    const data = {email};
    if ( ! first_submit ) {
      const errors = validate.email_confirm(data);
      setErrors(errors);
    }
  }, [email]);

  useEffect(() => {
    auth.student()
      .then((res) => {
        const student = res.data;
        if ( student.email ) {
          history.push('/');
        }
      });
  }, []);

  const onSubmit = ev => {
    ev.preventDefault();
    doConfirm();
  };
  const doConfirm = () => {
    const data = {email};
    const errors = validate.email_confirm(data);

    if ( Object.keys(errors).length > 0) {
      setErrors(errors);
      setFirstSubmit(false);
      return false;
    }

    api.post('/students/confirm', data)
      .then((res) => {
        localStorage.setItem('USR', sessionStorage.getItem('USR'));
        setSuccess(true);
      }).catch(error => {
        setPanic(error);
      });
  }

  if ( panic ) {
    throw panic;
  }
  return (
      <Wrap>
        <Helmet>
          <title>Eメール登録 | {siteName}</title>
        </Helmet>
        <Float>
          <div css={css`text-align: center; margin: 0 0 3rem`}><img src={LogoImage} css={css`max-width: 100%; width: 247.29px;`}/></div>
          {
            success ?
              <div>入力いただいたメールアドレス宛にメールを送信しました。<br/>届いたメールから確認URLへ接続してください。</div>
            :
            <Form action={onSubmit}>
              <p css={css`margin-bottom: 2rem`}>本人確認用のメールアドレスを登録してください</p>
              <div css={css`margin: 0 0 30px; max-width: 400px; width: 100%;`}>
                  <input type="text" className={errors.email && `hasError`} placeholder="メールアドレス" value={email} onChange={ev => setEmail(ev.target.value)}/>
                  {errors.email && <FormError text={errors.email}/>}
              </div>
              <BtnBorder name="メールアドレスを登録" action={()=> doConfirm()}/>
            </Form>
          }
        </Float>
      </Wrap>
  );
}
